

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { StudentService } from '@/lib/Student';

export function useStudentResendVerification(userId: string) {
  const queryClient = useQueryClient();
  return useMutation<void, Error, { token: string }>({
      mutationFn: async ({ token }) =>
        StudentService.resendVerificationEmail(userId, token),
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['user'] });
        queryClient.invalidateQueries({ queryKey: ['student-verification-status', userId] });
      },
    },
  );
}